import { RouteConfig, RouteConfigComponentProps } from "react-router-config";
import React from "react";

// Lazy load route components for code splitting
const FlipbookViewer = React.lazy(() => import("../components/ViewPdf").then(module => ({ default: module.FlipbookViewer })));
const SitePage = React.lazy(() => import("./page/site"));

const header = [
  {
    "path": "/",
    "label": "Home"
  },
  {
    "path": "/pdf-view", 
    "label": "PDF Diary"
  },
  {
    "path": "/dtdl-tech",
    "label": "Tech"
  },
  {
    "path": "/dtdl-life",
    "label": "Life"
  },
  {
    "path": "/joinus",
    "label": "JoinUs"
  },
  {
    "path": "/verticalcarousel",
    "label": "Vertical Carousel"
  },
  {
    "path": "/exp/*",
    "label": "Test Carousel"
  },
  {
    "path": "/:site",
    "label": "DTDL Page"
  }
]

export const fetchRoutes = async (): Promise<RouteConfig[]> => {
  try {
    return header.map((route) => {
      let component: React.ComponentType<RouteConfigComponentProps<any>>;

      switch (route.path) {
        case "/pdf-view":
          component = FlipbookViewer as unknown as React.ComponentType<RouteConfigComponentProps<any>>;
          break;
        default:
          // SitePage expects IProps but route config provides RouteConfigComponentProps
          // The component handles missing props gracefully, so we cast it
          component = SitePage as unknown as React.ComponentType<RouteConfigComponentProps<any>>;
      }

      return {
        path: route.path,
        exact: true,
        component,
      };
    });
  } catch (error) {
    console.error("Error fetching routes:", error);
    return [];
  }
};
